import { DeepPartial } from 'ts-essentials';
import { IMasterExtensions, IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { IMasterProps, IMasterData, IMasterExtensionData } from '@tencent/slide-sdk-model';
import { ConverterUtils } from '@src/slide/domain/ui-model/converter/convert-utils';

export class MasterPropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(sdkData: DeepPartial<IMasterProps>, uiData: IMasterModel): void {
        if (sdkData.themeId) {
            uiData.themeId = sdkData.themeId;
        }
        if (sdkData.clrMap) {
            uiData.clrMap = sdkData.clrMap;
        }
        if (sdkData.extensions) {
            uiData.extensions = {};
            this.convertMasterExtensionsDataFromSdkToUi(sdkData.extensions, uiData.extensions);
        }
    }

    public static convertPartialDataFromUiToSdk(uiData: DeepPartial<IMasterModel>, sdkData: IMasterData): void {}

    private static convertMasterExtensionsDataFromSdkToUi(
        sdkData: DeepPartial<IMasterExtensionData>,
        uiData: IMasterExtensions,
    ) {
        if (sdkData.templateId) {
            uiData.templateId =  ConverterUtils.convertJsonString(sdkData.templateId);
        }
    }
}
